<template>
  <div class="w-full bg-white">
    <!-- Modals -->
    <!-- Annual spyder upsell -->
    <PurchaseOnboardModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PurchaseOnboardModal from '../../components/account/subcriptionv2/PurchaseOnboardModal.vue'

export default {
  name: 'SuccessPurchaseView',
  components: {
    PurchaseOnboardModal
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUserSubscription'])
  }
}
</script>
